import { useTranslation } from 'react-i18next';

export const MarketplaceHeader = () => {
    const { t } = useTranslation();

    return <div className="text-xl font-medium mb-4">{t('marketplace.title')}</div>;
};
